import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b0022f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2b0022f2&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=2b0022f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0022f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomepageHeroSliderBF: require('/opt/build/repo/components/Homepage/HeroSliderBF.vue').default,HomepageHeroSlider: require('/opt/build/repo/components/Homepage/HeroSlider.vue').default,HomepageDifferentiation: require('/opt/build/repo/components/Homepage/Differentiation.vue').default,HomepageTopContentNew: require('/opt/build/repo/components/Homepage/TopContentNew.vue').default,CoursesWhy: require('/opt/build/repo/components/Courses/Why.vue').default,SchemaOrganization: require('/opt/build/repo/components/Schema/Organization.vue').default})
